import React, {Component} from 'react';
import { connect } from "react-redux";
import {endpointFieldChange} from "../../../../store/actions/endpoints";

class Method extends Component {

	render() {

		const { method, id, endpointFieldChange, sectionVisibility, premium } = this.props;

		const methods = [
			{
				name:  'Select a method',
				value: '',
				disabled: false
			},{
				name:  'Readable (GET)',
				value: 'GET',
				disabled: false
			}, {
				name:  'Creatable (POST)' + (!premium ? ' (PRO)' : ''),
				value: 'POST',
				disabled: !premium
			}, {
				name:  'Editable (PUT, PATCH)' + (!premium ? ' (PRO)' : ''),
				value: 'PUT, PATCH',
				disabled: !premium
			}, {
				name:  'Deletable (DELETE)' + (!premium ? ' (PRO)' : ''),
				value: 'DELETE',
				disabled: !premium
			}
		];

		return (
			<div id="poststuff" className="method-box">
				<div id="slugdiv" className="postbox ">
					<h2 className="hndle ui-sortable-handle" onClick={ e => endpointFieldChange( !sectionVisibility, id, 'methodSection' ) }><span>Select a method</span></h2>
					<div className="inside" style={{display: sectionVisibility ? 'block' : 'none'}}>
						<p>Choose one of the available methods below. Do not forget to follow the good REST practices for HTTP methods.</p>
						<select value={method} onChange={ e => endpointFieldChange( e.target.value, id, 'method' ) } >
							{methods.map((m, index) => <option key={index} disabled={this.props.methods.indexOf(m.value) !== -1 || m.disabled} value={m.value}>{m.name}</option>)}
						</select>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ( state, props ) => ({
	method: state.settings.endpoints[props.id].method,
	methods: state.existingMethods,
	sectionVisibility: state.settings.endpoints[props.id].methodSection,
  premium: state.premium
});

const mapDispatchToProps = dispatch => ({
	endpointFieldChange: ( value, endpointId, field ) => dispatch( endpointFieldChange( value, endpointId, field ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(Method);
